import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import heTranslation from './he/translation.json';
import enTranslation from './en/translation.json';

const fetchClientLanguage = async (): Promise<string> => {
  try {
    const response = await fetch('https://ipapi.co/json/'); // Replace with your preferred geolocation API
    const data = await response.json();
    const countryCode = data.country_code; // e.g., "IL" for Israel
    // Map country codes to languages
    if (countryCode === 'IL') return 'he'; // Hebrew for Israel
    return 'en'; // Default to English
  } catch (error) {
    console.error('Error fetching client location:', error);
    return 'he'; // Default to Hebrew in case of error
  }
};

const setHtmlDirection = (lang: string) => {
  const html = document.documentElement;
  if (lang === 'he') {
    html.lang = 'he';
    html.dir = 'rtl';
  } else {
    html.lang = 'en';
    html.dir = 'ltr';
  }
};

const initializeI18n = async () => {
  const clientLang = await fetchClientLanguage();
  setHtmlDirection(clientLang); 

  i18next
  .use(initReactI18next)
  .init({
    lng: clientLang, // Set detected language
    debug: true,
    resources: {
      he: {
        translation: heTranslation,
      },
      en: {
        translation: enTranslation,
      },
    },
    fallbackLng: 'en', // Fallback to English if language is not supported
    returnNull: false,
  })
  .then(() => {
    i18next.reloadResources().then(() => {
      console.log("Translation resources reloaded.");
    });
  });
}


i18next.on('languageChanged', (lng) => {
  setHtmlDirection(lng);
});

export default initializeI18n;